import script from "./Global.vue?vue&type=script&setup=true&lang=js"
export * from "./Global.vue?vue&type=script&setup=true&lang=js"

import "./Global.vue?vue&type=style&index=0&id=74b975dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b975dd"]])

export default __exports__